module.exports = __webpack_public_path__ + "static/media/hotels-icon-blue.37c7c0bf.PNG";